import "@assets/css/report.css";
import ReportsListView from "../components/ReportsListView";

export default function Report() {
  return (
    <main className="flex-1 overflow-auto p-6" id="mainContent">
      <ReportsListView />
    </main>
  );
}
